export const STORAGE_KEY = '_lastActivityTimestamp';